require('./brokerSubscriptionView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { LabelDate } = require('commonsComponents/labelDate');
const BrokerSubscriptionWizard = require('components/broker/brokerSubscription/brokerSubscriptionWizard');
const BrokerSubscriptionSuccess = require('components/broker/brokerSubscription/brokerSubscriptionSuccess/brokerSubscriptionSuccess');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @helpers
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject, formatAmount, formatCurrency } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const productFileActions = require('actions/brokerGetProductFile');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');

// @constants
const {
    CHARGE_ACCOUNT_PREFIX,
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    HYPHEN,
    MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION,
    BROKER_MIFID_VERSION_2,
    BROKER_MIFID_FUND_GREEN,
    BROKER_TYPE_RIGHT_NEW_DECIMALS,
    EURO_TEXT,
    BROKER_BUY_SCREEN
} = require('constants/index');

const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class BrokerSubscriptionView extends React.Component {
    constructor(props) {
        super(props);

        this.buildWizard = this.buildWizard.bind(this);
        this.buildSideColumn = this.buildSideColumn.bind(this);
        this.buildSuccess = this.buildSuccess.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.breadcrumb = [
            {
                text: formatText('subscription-investments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('subscription-corporateOperations'),
                url: '/myprofile/broker/corporatesOperations'
            },
            {
                text: formatText('subscription-capitalIncrease'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { immBrokerSubscription, getProductFile, history } = this.props;
        const isin = immBrokerSubscription.getIn(['value', 'isin'], false);
        const iso = immBrokerSubscription.getIn(['value', 'iso'], false);

        if (iso && isin) {
            getProductFile(isin, iso, BROKER_BUY_SCREEN);
        } else {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        }
    }

    componentWillUnmount() {
        const { resetProductFile } = this.props;
        resetProductFile();
    }

    getImmContract() {
        return this.props.immBrokerSubscription.get('selectedContract');
    }

    getImmOperation() {
        return this.props.immBrokerSubscription.get('value');
    }

    getImmStockOfContract() {
        const immStocks = this.props.immBrokerMyInvestments.getIn(['products', 'stocks', 'stocks']);
        const immContract = this.getImmContract();

        if (immStocks && immContract) {
            const selectedContractNumber = immContract.getIn(['contract', 'number']);
            const selectedProductNumber = immContract.getIn(['contract', 'product']);

            return immStocks.find(immStock => (
                immStock.get('product') == selectedProductNumber &&
                immStock.get('contract') == selectedContractNumber
            ));
        } else {
            return undefined;
        }
    }

    getMifidEventCode() {
        const immOperation = this.getImmOperation();
        return immOperation ? immOperation.get('eventCode') : undefined;
    }

    getMifidFeeNumbers() {
        const immStockOfContract = this.getImmStockOfContract();
        return immStockOfContract ? immStockOfContract.get('shares') : undefined;
    }

    getMifidValueCode() {
        const immOperation = this.getImmOperation();
        return immOperation ? immOperation.get('valueCode') : undefined;
    }

    buildFullContractNumber() {
        const { immCorporatesOperations } = this.props;
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const contractProductNumber =
            selectedContract.getIn(['cuenta', 'digitodecontrol']) +
            selectedContract.getIn(['cuenta', 'fullNumber']);

        return CHARGE_ACCOUNT_PREFIX + contractProductNumber;
    }

    buildMifidBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('corporatesOperations-corporatesOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            }
        ];
    }

    buildMifidOptions() {
        const immContract = this.getImmContract();
        const immOperation = this.getImmOperation();

        return {
            operationType: BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION,
            breadcrumb: this.buildMifidBreadcrumb(),
            selectedContract: immContract ? immContract.toJS() : null,
            selectedOperation: immOperation ? immOperation.toJS() : null
        };
    }

    buildQuotationSection() {
        const { immProductFile } = this.props;
        const quotationValue = immProductFile.getIn(['productValue', 'amount'], 0);
        const quotationDate = immProductFile.get('updatePriceDate');
        const quotationTime = immProductFile.get('updatePriceTime');
        let quotationSection;

        if(quotationDate && quotationValue && quotationTime) {
            const formattedDate = DateHelper.getFormattedDate(quotationDate);
            const quotationAmount = formatAmount(quotationValue, getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);
            const currency = formatCurrency(EURO_TEXT); // @hardcoded
            quotationSection = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        {quotationAmount} {currency}
                    </div>
                    <div className="broker-rights-buy-sidebar__item-additional-information">
                        {formattedDate}, {quotationTime}
                    </div>
                </div>
            );
        } else {
            quotationSection = (
                <div className="broker-rights-buy-sidebar__item">
                    <div className="broker-rights-buy-sidebar__item-label">
                        <FormattedText value="broker-rightsQuotation" format="uppercase" />
                    </div>
                    <div className="broker-rights-buy-sidebar__item-name">
                        {HYPHEN}
                    </div>
                </div>
            );
        }

        return quotationSection;
    }

    buildSideColumn() {
        const { immBrokerSubscription, immCorporatesOperations } = this.props;
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const fullContractNumber = this.buildFullContractNumber();
        const immAssociatedAccount = immBrokerSubscription.get('associatedAccount');
        const associatedAccountBalance = immAssociatedAccount.getIn(['balance', 'amount']);
        const associatedAccountCurrency = immAssociatedAccount.getIn(['balance', 'currency']);

        const language = getLanguage();
        const amountObject = {
            amount: associatedAccountBalance,
            currency: associatedAccountCurrency
        };
        const plainAmountObject = getPlainAmountObject(amountObject);
        const associatedAccountLabel = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );
        const interventionTypes = formatText(`interventionTypes-${selectedContract.get('intervention').trim()}`);
        const proportion = immBrokerSubscription.getIn(['value', 'proportion']);

        return (
            <div>
                <OKSectionBox>
                    <h4><FormattedText value="subscription-value" /></h4>

                    <div className="broker-subscription-view__sidecolumn-header">
                        <h3 className="broker-subscription-view__sidecolumn-title">
                            {immBrokerSubscription.getIn(['value', 'descriptionValue'])}
                        </h3>
                    </div>

                    {this.buildQuotationSection()}

                    <div className="broker-subscription-view__sidecolumn-information">
                        <h5 className="broker-subscription-view__sidecolumn-information-title">
                            <FormattedText value="subscription-contract" format="uppercase" />
                        </h5>
                        <div className="broker-subscription-view__sidecolumn-information-primary-text">
                            {immBrokerSubscription.get('walletAccountType')}
                        </div>
                        <div className="broker-subscription-view__lighter-fg">
                            <FormattedText
                                value="subscription-number"
                                injectedStrings={[fullContractNumber]}
                            />
                        </div>
                    </div>

                    <div className="broker-subscription-view__sidecolumn-information">
                        <h5 className="broker-subscription-view__sidecolumn-information-title">
                            <FormattedText value="subscription-owner" format="uppercase" />
                        </h5>
                        <div className="broker-subscription-view__sidecolumn-information-primary-text">
                            {immBrokerSubscription.get('owner')}
                        </div>
                        <div className="broker-subscription-view__lighter-fg">
                            <FormattedText
                                value="broker-rightsSubscriptionInterventionLabel"
                                injectedStrings={[interventionTypes]}
                            />
                        </div>
                    </div>

                    <div className="broker-subscription-view__sidecolumn-information">
                        <h5 className="broker-subscription-view__sidecolumn-information-title">
                            <FormattedText
                                value="subscription-associatedAccount"
                                format="uppercase"
                            />
                        </h5>
                        <div className="broker-subscription-view__sidecolumn-information-primary-text">
                            {immAssociatedAccount.get('number')}
                        </div>
                        <div className="broker-subscription-view__lighter-fg">
                            (
                            <FormattedText value="subscription-associatedAccountBalance" />
                            {' '}
                            {associatedAccountLabel}
                            )
                        </div>
                    </div>

                    <div className="broker-subscription-view__sidecolumn-information">
                        <h5 className="broker-subscription-view__sidecolumn-information-title">
                            <FormattedText value="subscription-date" format="uppercase" />
                        </h5>
                        <div className="broker-subscription-view__sidecolumn-information-primary-text">
                            <LabelDate
                                date={immBrokerSubscription.getIn(['value', 'endDate'])}
                                language={language}
                                today={LABEL_DATE_TODAY}
                                yesterday={LABEL_DATE_YESTERDAY}
                            />
                        </div>
                    </div>

                    <div className="broker-subscription-view__sidecolumn-information">
                        <h5 className="broker-subscription-view__sidecolumn-information-title">
                            <FormattedText
                                value="broker-subscriptionProportion"
                                format="uppercase"
                            />
                        </h5>
                        <div className="broker-subscription-view__sidecolumn-information-primary-text">
                            {proportion}
                        </div>
                    </div>
                </OKSectionBox>
                <OKSectionBox className="broker-subscription-view__sidecolumn-extra-info">
                    <h4><FormattedText value="brokerSubscription-extraInfoTitle" format="uppercase" /></h4>
                    <p><FormattedText value="brokerSubscription-extraInfoMessage1" /></p>
                    <p><FormattedText value="brokerSubscription-extraInfoMessage2" /></p>
                    <p><FormattedText value="brokerSubscription-extraInfoMessage3" /></p>
                </OKSectionBox>
            </div>
        );
    }

    buildSuccess() {
        const { immBrokerSubscription } = this.props;
        const fullContractNumber = this.buildFullContractNumber();

        return (
            <BrokerSubscriptionSuccess
                immBrokerSubscription={immBrokerSubscription}
                fullContractNumber={fullContractNumber}
            />
        );
    }

    buildWizard() {
        const {
            immProfileFields,
            immPreContractualMail,
            sendPreContractualMail,
            resetPrecontractualMail,
            requestProfile,
            immCorporatesOperations,
            setDocumentsRead,
            immBrokerSubscription,
            onChangeManifest,
            onSubmitOperation
        } = this.props

        const immCorporatesOperation = this.getImmOperation();

        return (
            <BrokerSubscriptionWizard
                immBrokerSubscription={immBrokerSubscription}
                onChangeManifest={onChangeManifest}
                onCancelOperation={this.handleCancel}
                onPrevious={this.handlePrevious}
                onSubmitOperation={onSubmitOperation}
                immCorporatesOperation={immCorporatesOperation}
                currency={immCorporatesOperations.getIn(['selectedContract', 'associatedAccount', 'balance', 'currency'])}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                immPreContractualMail={immPreContractualMail}
                sendPreContractualMail={sendPreContractualMail}
                resetPrecontractualMail={resetPrecontractualMail}
                setDocumentsRead={setDocumentsRead}
            />
        );
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    handlePrevious() {
        this.props.history.goBack();
    }

    wrapMifid(view) {
        const immOperation = this.getImmOperation();
        const productName = HYPHEN;
        const productUrl = BROKER_CORPORATE_OPERATIONS_URL;
        const continuationUrl = MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL;
        const productIsin = immOperation ? immOperation.get('isin') : '';
        const productIso = immOperation ? immOperation.get('iso') : '';
        const mifidOptions = this.buildMifidOptions();

        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={productIsin}
                productMarketId={productIso}
                feeNumbers={this.getMifidFeeNumbers()}
                valueCode={this.getMifidValueCode()}
                eventCode={this.getMifidEventCode()}
                productMifidId={BROKER_MIFID_FUND_GREEN}
                mifidOptions={mifidOptions}
            >
                {view}
            </BrokerMiFIDBehavior>
        );
    }

    render() {
        const { immBrokerSubscription, immVariables } = this.props;
        const isin = immBrokerSubscription.getIn(['value', 'isin'], false);
        const iso = immBrokerSubscription.getIn(['value', 'iso'], false);
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        let content;
        let view;

        if (!isin || !iso) {
            content = null;
        } else if (immBrokerSubscription.get('finished')) {
            content = this.buildSuccess();
        } else {
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4" id="printable-wizard">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        view = (<section className="broker-subscription-view">
            <OKCover size="medium" section="broker">
                <OKHeaderSubPage
                    breadcrumbConfig={this.breadcrumb}
                    subtitleLeft={formatText('subscription-subtitle')}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle('subscription-title')}
                >
                    <OKButton
                        modifier="primary"
                        to={fees_url}
                    >
                        <FormattedText value="subscription-commissions" />
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
            <section className="broker-subscription-view__body">
                {content}
            </section>
        </section>);

        if (isin && iso) {
            return this.wrapMifid(view);
        } else {
            return view;
        }
    }
}

BrokerSubscriptionView.propTypes = {
    immBrokerSubscription: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onSubmitOperation: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    getProductFile: PropTypes.object.isRequired,
    resetProductFile: PropTypes.object.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    immVariables: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerSubscriptionView;
module.exports.BrokerSubscriptionView = connect(
    state => ({
        immProfileFields: state.profile,
        immPreContractualMail: state.preContractualMail,
        immBrokerSubscription: state.brokerSubscription,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immProductFile: state.brokerProductFile,
        immVariables: state.globalVariables
    }),
    {
        onChangeManifest: BrokerSubscriptionActions.changeManifest,
        onSubmitOperation: BrokerSubscriptionActions.submitOperation,
        sendPreContractualMail: preContractualMailActions.sendBrokerPreContractualMail,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        requestProfile: profileActions.requestProfile,
        getProductFile: productFileActions.getProductFile,
        resetProductFile: productFileActions.reset,
        setDocumentsRead: BrokerSubscriptionActions.setDocumentsRead,
    }
)(withRouter(BrokerSubscriptionView));
